export const VerticalDividerIcon = () => (
  <svg
    width="1"
    height="53"
    viewBox="0 0 1 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="0.5"
      y1="0.5"
      x2="0.499998"
      y2="52.5"
      stroke="url(#paint0_linear_6292_8542)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6292_8542"
        x1="-0.5"
        y1="0.5"
        x2="-0.500002"
        y2="52.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E7E6EB" stopOpacity="0" />
        <stop offset="0.543269" stopColor="#E7E6EB" />
        <stop offset="1" stopColor="#E7E6EB" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
